// Коды аудитории те же, что у телеграмной рассылки: их считает один и тот же
// селектор на бэкенде (Domain.BroadcastAudiences). Рассылка в приложении,
// рассылка пушами и подсчёт охвата ходят по этим же кодам, поэтому список живёт
// в одном месте и не расходится между экранами.
export const audienceOptions = [
	{ value: 0, label: "Всем" },
	{ value: 1, label: "Новым профилям" },
	{ value: 2, label: "С правками" },
	{ value: 3, label: "Незаполненным профилям" },
	{ value: 4, label: "В заморозке" },
	{ value: 5, label: "Никогда не покупали" },
	{ value: 6, label: "Без подписки" },
	{ value: 7, label: "Москва" },
	{ value: 8, label: "Армения" },
	{ value: 9, label: "Россия" },
];

export const sexOptions = [
	{ value: 0, label: "Всем" },
	{ value: 1, label: "Мужчинам" },
	{ value: 2, label: "Женщинам" },
];

// Поверхности доставки пуша. Массовая рассылка выбирает одну на человека
// (приложение важнее браузера), пробная отправка умеет спросить обе сразу.
export const channelLabels = {
	mobile: "мобильное приложение",
	web: "браузер",
};

export const channelLabel = (value) => channelLabels[value] ?? value ?? "—";

// Пробная отправка: «обе сразу» — разумное значение по умолчанию. Смысл
// репетиции в том, чтобы увидеть каждую поверхность; массовая рассылка,
// наоборот, намеренно выбирает человеку ровно одну.
export const testChannelOptions = [
	{
		value: "both",
		label: "Приложение и браузер сразу",
		hint: "По одному уведомлению на каждую поверхность — так видно обе. Массовая рассылка так не делает.",
	},
	{
		value: "mobile",
		label: "Только мобильное приложение",
		hint: "Уйдёт только на телефон, даже если подписка браузера тоже есть.",
	},
	{
		value: "web",
		label: "Только браузер",
		hint: "Уйдёт только в браузер — удобно, когда проверяется именно веб-пуш.",
	},
	{
		value: "auto",
		label: "Как в массовой рассылке",
		hint: "Канал выберет сервер: приложение важнее браузера. Ровно то, что получит человек из аудитории.",
	},
];

// Ответы пробной отправки, которые выглядят как неудача, но ошибкой не
// являются: так у этого конкретного человека и устроено.
//
// Причины push_disabled здесь нет: тумблер уведомлений объявление не гасит
// (на сервере у рассылки и её репетиции PushPreferencePolicy.IgnoresUserSetting),
// поэтому такой ответ пробная отправка вернуть не может. Если код всё же
// придёт, его покажет запасная строка ниже — врать заведомо неверным
// объяснением хуже, чем показать сам код.
export const testSkipReasons = {
	no_target:
		"Отправлять некуда: нет ни приложения с разрешением на уведомления, ни подписки браузера. Обычно это значит, что человек не заходил в приложение или отозвал разрешение.",
	no_mobile_target:
		"В приложении отправлять некуда: нет живого устройства с разрешением на уведомления. Это не поломка — просто на этой поверхности человека нет.",
	no_web_target:
		"В браузере отправлять некуда: живой подписки нет. Это не поломка — просто на этой поверхности человека нет.",
};

export const testSkipReason = (code) =>
	testSkipReasons[code] ?? `Причина: ${code || "не указана"}.`;

// Где картинка в уведомлении видна на самом деле. Сервер присылает то же самое
// в support, но подпись нужна и до загрузки — иначе картинку выберут вслепую.
export const PUSH_IMAGE_IOS_WARNING =
	"На iPhone картинки не будет: в сборке приложения нет Notification Service Extension. Уведомление придёт с заголовком и текстом — это не сбой отправки.";

export const PUSH_IMAGE_SUMMARY =
	"Картинка видна на Android и в Chrome/Edge. На iPhone её не будет совсем, Firefox и Safari поле картинки игнорируют. Текст уведомления доходит везде и всегда.";

// В чате ограничений нет: картинка приходит обычным сообщением с фотографией, а
// текст становится подписью под ней — так же, как снимок в переписке.
export const APP_IMAGE_SUMMARY =
	"Картинка придёт фотографией в чат от профиля Jerm — её видно и в приложении, и в вебе. Текст станет подписью под ней; можно отправить и одну картинку без текста.";

export const BOTH_IMAGE_SUMMARY = `${APP_IMAGE_SUMMARY} В уведомлении та же картинка видна на Android и в Chrome/Edge, а на iPhone её не будет — там придёт только текст.`;

export const audienceLabel = (value) =>
	audienceOptions.find((option) => option.value === value)?.label ?? value;

export const sexLabel = (value) =>
	sexOptions.find((option) => option.value === value)?.label ?? value;

// Число с разрядами: «12 840» читается с первого взгляда, «12840» — нет, а
// именно по этим числам принимается решение об отправке.
export const formatCount = (value) =>
	typeof value === "number" && Number.isFinite(value)
		? value.toLocaleString("ru-RU")
		: "—";

/**
 * Русское склонение для «человек получит уведомление»: подтверждение массовой
 * отправки должно читаться как фраза, а не как строка из отчёта.
 */
export const plural = (count, one, few, many) => {
	const n = Math.abs(count) % 100;
	const n1 = n % 10;
	if (n > 10 && n < 20) return many;
	if (n1 > 1 && n1 < 5) return few;
	if (n1 === 1) return one;
	return many;
};
